import { type FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { DropdownCard, type IDropdownItem } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'

type INewMessageActionDropdownItemProps = {
  onClick?: () => void
}

const defaultItem: IDropdownItem = {
  id: 'new_message',
  iconL: 'messageTextSquare',
  hotKey: 'M',
  label: 'New message',
  ariaLabel: 'getNewConversationNewMessageButtonSelector',
}

export const NewMessageActionDropdownItem: FC<INewMessageActionDropdownItemProps> = observer(
  ({ onClick }) => {
    const { callStore, conversationStore } = useEntitiesContext()
    const { isActionDisabled } = conversationStore
    const { isStatusClosed } = callStore
    const [dropdownItem, setDropdownItem] = useState<IDropdownItem>(defaultItem)

    useEffect(() => {
      const updatedItem: IDropdownItem = { ...defaultItem }

      if (isActionDisabled) {
        updatedItem.disabled = true
        updatedItem.parentTooltipProps = {
          label: 'Verify your number to send messages',
          placement: 'right-end',
          fullWidth: true,
        }
      }

      setDropdownItem(updatedItem)
    }, [isActionDisabled, isStatusClosed])

    return (
      <DropdownCard
        item={dropdownItem}
        onChange={() => {
          onClick?.()
        }}
      />
    )
  }
)
